import { useEffect, useRef, useState } from 'react';

export default function useAllImagesLoaded(wrapperRef) {
  const counterRef = useRef(0);
  const counterImg = useRef(0);
  const [ready, setReady] = useState(false);

  function onLoad() {
    counterRef.current -= 1;
    if (counterRef.current === 0) {
      setReady(true);
    }
  }

  useEffect(() => {
    if (!wrapperRef.current) {
      return;
    }

    const imgs = wrapperRef.current.querySelectorAll('img');
    const canvases = wrapperRef.current.querySelectorAll('canvas');
    counterRef.current = imgs.length + canvases.length;
    counterImg.current = imgs.length;

    [].forEach.call(imgs, (img) => {
      if (img.complete) {
        onLoad();
        counterImg.current -= 1;
      } else {
        // eslint-disable-next-line no-param-reassign
        img.onload = () => {
          counterImg.current -= 1;
          onLoad();
        };
        // eslint-disable-next-line no-param-reassign
        img.onerror = () => {
          counterImg.current -= 1;
          onLoad();
        };
      }
    });

    [].forEach.call(canvases, (canvas) => {
      canvas.addEventListener('loadimage', () => {
        onLoad();
      });
      canvas.addEventListener('errorimage', () => {
        onLoad();
      });
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return ready;
}
